// extracted by mini-css-extract-plugin
module.exports = {"recipe":"recipe_recipe__1IG3a","image":"recipe_image__234HM","footer":"recipe_footer__eRfbu"};